import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
import cx from 'clsx';

const useStyles = (params = {}) => {
    const { props } = params;
    const { src } = props;

    return makeStyles(theme => ({
        avatar: {
            background: src ? '#fff' : '#FEF2E8', //'rgba(252, 130, 31, 0.1)',
            color: 'rgb(252,130,31)',
        },
    }));
};

const AfitdAvatar = props => {
    const { isHidden, className, alt = 'Profile Image', children = '?', ...otherProps } = props;
    const classes = useStyles({ props })();

    return isHidden ? null : (
        <Avatar className={cx(classes.avatar, className)} alt={alt} {...otherProps}>
            {children}
        </Avatar>
    );
};

export default AfitdAvatar;
